import {useQuery} from '@tanstack/react-query';
import {getCustomer} from 'api/requests';
import {useAuth} from 'hooks';
import {QueryKeyEnum} from 'types';
import {ICustomerResponse} from 'types';

export const useCustomerQuery = (options?: any) => {
  const {isAuthenticated} = useAuth();

  return useQuery<ICustomerResponse>({
    queryKey: [QueryKeyEnum.CUSTOMER, isAuthenticated],
    queryFn: async () => {
      return await getCustomer();
    },
    enabled: !!isAuthenticated,
    ...options,
  });
};
